<template>
  <div class="person-table">
    <QS-h4-title title="运营情况-个人" :content="dateText"/>
    <QS-common-table
      :max-height="400"
      :data="tableData"
      :columns="columns"
      :pagination="false"
    />
  </div>
</template>
<script>
import config from './config'

export default {
  props: {
    dateText: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    dateStr: {
      type: String,
      default: '',
    },
  },
  data() {
    const { columns } = config.call(this, { dateStr: this.dateStr })
    return {
      columns,
    }
  },
  watch: {
    dateStr: {
      handler(val) {
        const { columns } = config.call(this, { dateStr: val })
        this.columns = columns
      },
    },
  },
}
</script>
<style scoped lang='scss'>
.person-table{
  margin-top: 24px;
}
</style>
